import { Entity } from "@dinahmoe/dmafjs-core";

class UserEvent extends Entity {
  namespace = "visual:userEvent";
}

const userEvent = new UserEvent();
export { UserEvent, userEvent };
